<template>
    <div>
        <v-card class="primary darken-2" style="">
            <v-card-text style="font-size: 12px; ">
                <p class="white--text subheading pa-0 ma-0 text-xs-center"><b> Congrats!!!</b> you just completed step one, complete the next steps </p>
            </v-card-text>
        </v-card>

        <v-card color="white pa-3">
            <b>Step 2/3: Your Njangi Contribution Info</b>
            <v-layout wrap row>
                <v-flex xs12 sm6>
                    <v-layout row>
                        <v-flex xs2>
                            <i class="teal--text fas fa-money-bill fa-2x mt-3 pr-1"> </i>
                        </v-flex>
                        <v-flex xs9>
                            <v-select
                                class="pt-0 mt-3" color="teal"
                                v-model="njangi_contrib_interval"
                                ref="njangi_contrib_interval"
                                :items="cycleOptions"
                                item-text="text"
                                item-value="value"
                                :rules="[v => !!v || 'Njangi Interval Type is required']"
                                label="Njangi Interval Type"
                                required
                                @change="onCycleChange"
                                :loading="loadingAmounts"
                                :disabled="loadingAmounts"
                            ></v-select>
                        </v-flex>
                        <v-flex xs2>
                            <v-btn @click.stop="$store.commit('activateDialog', true); njangi_contrib_amount_help = true; getHelpMessage()" flat fab small outline color="black" class="my-4" style="height:20px; width: 20px">
                                <i class="fas fa-question"> </i>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12 sm6>
                    <v-layout row>
                        <v-flex xs2 sm1>
                            <i class="teal--text fas fa-calendar fa-2x mt-3 pr-1"> </i>
                        </v-flex>
                        <v-flex xs9 sm10>
                            <v-select
                                class="pt-0 mt-3" color="teal"
                                v-model="njangi_contrib_amount"
                                ref="njangi_contrib_amount"
                                :items="contributionOptions"
                                item-text="display_text"
                                item-value="value"
                                :rules="[v => !!v || 'Contribution Amount is required']"
                                label="Contribution Amount"
                                :loading="loadingAmounts"
                                :disabled="loadingAmounts || !njangi_contrib_interval"
                                required
                                @change="updateFeeDisplay"
                            >
                                <template v-slot:prepend-inner>
                                    <v-icon color="teal">mdi-currency-usd</v-icon>
                                </template>
                            </v-select>
                        </v-flex>
                        <v-flex xs2>
                            <v-btn @click.stop="$store.commit('activateDialog', true); njangi_contrib_amount_help = true; getHelpMessage()" flat fab small outline color="black" class="my-4" style="height:20px; width: 20px">
                                <i class="fas fa-question"> </i>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-flex>

                <!-- Affichage des frais comme dans le premier code -->
                <v-flex xs12 v-if="selectedContribution && selectedContribution.fee > 0">
                    <v-alert type="info" dense class="mt-2" outlined>
                        <div class="d-flex justify-space-between align-center mb-1">
                            <span class="caption">Base Contribution:</span>
                            <span class="caption font-weight-medium">{{ formatAmount(selectedContribution.value) }} F CFA</span>
                        </div>
                        <div class="d-flex justify-space-between align-center mb-1">
                            <span class="caption" style="color: #ff9800;">Transaction Fee:</span>
                            <span class="caption font-weight-medium" style="color: #ff9800;">+ {{ formatAmount(selectedContribution.fee) }} F CFA</span>
                        </div>
                        <v-divider class="my-1"></v-divider>
                        <div class="d-flex justify-space-between align-center">
                            <span class="body-2 font-weight-bold">Total to Pay:</span>
                            <span class="body-2 font-weight-bold">{{ formatAmount(selectedContribution.total) }} F CFA</span>
                        </div>
                    </v-alert>
                </v-flex>

                <v-flex xs12 v-if="!njangi_contrib_interval && !loadingAmounts">
                    <v-alert type="warning" dense class="mt-2" outlined>
                        Please select a collection cycle first
                    </v-alert>
                </v-flex>

                <v-flex xs12>
                    <v-layout row>
                        <v-flex xs2 sm1>
                            <i class="teal--text fas fa-pen-to-square fa-2x mt-3"> </i>
                        </v-flex>
                        <v-flex xs9 sm10>
                            <v-textarea class="pa-0 mt-3" name="input-7-1" auto-grow v-model="assetDescription" ref="assets_description" label="Describe your available assets" :rules="[v => !!v || 'Your asset description is required']" background-color="grey lighten-4" color="teal" rows="2" box row-height="20"></v-textarea>
                        </v-flex>
                        <v-flex xs2>
                            <v-btn @click.stop="$store.commit('activateDialog', true); asset_description_help = true; getHelpMessage()" flat fab small outline color="black" class="my-4" style="height:20px; width: 20px">
                                <i class="fas fa-question"> </i>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12>
                    <v-layout row>
                        <v-flex xs2 sm1>
                            <i class="teal--text fas fa-bank fa-2x mt-3"> </i>
                        </v-flex>
                        <v-flex xs9 sm10>
                            <v-textarea class="pa-0 mt-3" name="input-7-1" auto-grow v-model="bankAccountDescription" ref="bank_account_description" label="Describe your bank statement" :rules="[v => !!v || 'Your bank statement description is required']" background-color="grey lighten-4" color="teal" rows="2" box row-height="20"></v-textarea>
                        </v-flex>
                        <v-flex xs2>
                            <v-btn @click.stop="$store.commit('activateDialog', true); bank_statement_description_help = true; getHelpMessage()" flat fab small outline color="black" class="my-4" style="height:20px; width: 20px">
                                <i class="fas fa-question"> </i>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
            <div class="text-xs-center">
                <v-btn @click="configureNewGroup()" class="white--text elevation-6" type="submit" small round color="teal">
                    <span> Next</span>
                </v-btn>
            </div>
        </v-card>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        data() {
            return {
                njangi_contrib_amount_help: false,
                asset_description_help: false,
                bank_statement_description_help: false,
                application: [],
                loadingAmounts: false,

                njangi_contrib_amount: "",
                assetDescription: "",
                njangi_contrib_interval: '',
                bankAccountDescription: "",

                // Options pour les cycles
                cycleOptions: [
                    { text: 'Daily', value: 'Daily' },
                    { text: 'Weekly', value: 'Weekly' },
                    { text: 'Monthly', value: 'Monthly' }
                ],

                // Options de contribution avec frais (chargées dynamiquement)
                contributionOptions: [],
                selectedContribution: null,
            }
        },
        mounted() {
            document.title = "PettyCash | Configure Njangi Application"
            this.getNjangiApplication()
        },

        methods: {
            async getNjangiApplication() {
                const application_id = this.$route.params.application_id

                await axios
                    .get('/api/v1/njangi/get/user/application/detail/' + application_id + '/')
                    .then(response => {
                        console.log(response.data)
                        this.application = response.data

                        // Si l'application a déjà un cycle défini, charger les montants
                        if (this.application.collecting_cycle) {
                            this.njangi_contrib_interval = this.application.collecting_cycle
                            this.loadContributionAmounts()
                        }
                    })
                    .catch(error => {
                        if (error.response) {
                            this.$store.commit('setSnackBarMessage', error.response.status + " " + error.response.statusText)
                            this.$store.commit('setSnackBarColor', "red darken-4")
                            this.$store.commit('activateSnackBar', true)
                        } else {
                            this.$store.commit('setSnackBarMessage', "An error occured, please check your internet connection and try again later.")
                            this.$store.commit('setSnackBarColor', "red darken-4")
                            this.$store.commit('activateSnackBar', true)
                        }
                    })
                this.$store.commit('setIsLoading', false)
            },

            async loadContributionAmounts() {
                if (!this.njangi_contrib_interval) return

                this.loadingAmounts = true

                try {
                    const response = await axios.get('/api/v1/njangi/contribution-amounts/', {
                        params: { cycle: this.njangi_contrib_interval }
                    })

                    this.contributionOptions = response.data.contributions

                    // Réinitialiser la sélection si le cycle change
                    this.njangi_contrib_amount = ""
                    this.selectedContribution = null

                } catch (error) {
                    console.error('Error loading contribution amounts:', error)
                    this.$store.commit('setSnackBarMessage', 'Error loading contribution amounts')
                    this.$store.commit('setSnackBarColor', "red darken-4")
                    this.$store.commit('activateSnackBar', true)
                } finally {
                    this.loadingAmounts = false
                }
            },

            onCycleChange() {
                // Charger les montants de contribution quand le cycle change
                this.loadContributionAmounts()
            },

            updateFeeDisplay() {
                if (this.njangi_contrib_amount) {
                    this.selectedContribution = this.contributionOptions.find(
                        opt => opt.value === this.njangi_contrib_amount
                    )
                } else {
                    this.selectedContribution = null
                }
            },

            formatAmount(amount) {
                return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
            },

            async configureNewGroup() {
                if (this.njangi_contrib_interval === "") {
                    this.$store.commit('setSnackBarMessage', "Please select the contribution intervals you will be at ease with daily/weekly/monthly every njangi session")
                    this.$store.commit('setSnackBarColor', "red darken-4")
                    this.$store.commit('activateSnackBar', true)
                    this.$refs.njangi_contrib_interval.focus()
                }
                else if (this.njangi_contrib_amount === "") {
                    this.$store.commit('setSnackBarMessage', "Please select the <b>amount</b> you will be comfortable contributing for each session")
                    this.$store.commit('setSnackBarColor', "red darken-4")
                    this.$store.commit('activateSnackBar', true)
                    this.$refs.njangi_contrib_amount.focus()
                }
                else if (this.assetDescription === "") {
                    this.$store.commit('setSnackBarMessage', "Please describe your assets so we know how best to consider your application.")
                    this.$store.commit('setSnackBarColor', "red darken-4")
                    this.$store.commit('activateSnackBar', true)
                    this.$refs.assets_description.focus()
                }
                else if (this.bankAccountDescription === "") {
                    this.$store.commit('setSnackBarMessage', "Please describe your bank details so we know how best to consider your application.")
                    this.$store.commit('setSnackBarColor', "red darken-4")
                    this.$store.commit('activateSnackBar', true)
                    this.$refs.bank_account_description.focus()
                }
                else {
                    this.$store.commit('setIsLoading', true)
                    const application_id = this.$route.params.application_id

                    // Récupérer le montant total avec frais
                    const totalAmount = this.selectedContribution ? this.selectedContribution.total : this.njangi_contrib_amount

                    await axios
                        .post('/api/v1/njangi/configure/new_group/', {
                            'application_id': application_id,
                            'njangi_contrib_amount': totalAmount, // Envoyer le montant total avec frais
                            'base_contribution': this.selectedContribution ? this.selectedContribution.value : this.njangi_contrib_amount, // Montant de base
                            'transaction_fee': this.selectedContribution ? this.selectedContribution.fee : 0, // Frais de transaction
                            'njangi_contrib_interval': this.njangi_contrib_interval,
                            'assetDescription': this.assetDescription,
                            'bankAccountDescription': this.bankAccountDescription
                        })
                        .then(response => {
                            this.$store.commit('setSnackBarMessage', response.data[0].text)
                            this.$store.commit('setSnackBarColor', response.data[0].color)
                            this.$store.commit('activateSnackBar', true)
                            let router = this.$router
                            setTimeout(function() {
                                router.push('/njangi/groups/new_group/three/')
                            }, 4000)
                        })
                        .catch(error => {
                            if (error.response) {
                                this.$store.commit('setSnackBarMessage', error.response.status + " " + error.response.statusText)
                                this.$store.commit('setSnackBarColor', "red darken-4")
                                this.$store.commit('activateSnackBar', true)
                            } else {
                                this.$store.commit('setSnackBarMessage', "An error occured, please check your internet connection and try again later.")
                                this.$store.commit('setSnackBarColor', "red darken-4")
                                this.$store.commit('activateSnackBar', true)
                            }
                        })
                    this.$store.commit('setIsLoading', false)
                }
            },

            getHelpMessage() {
                if (this.njangi_contrib_amount_help) {
                    this.njangi_contrib_amount_help = false
                    this.$refs.njangi_contrib_amount.focus()
                    this.$store.commit('setDialogTitle', "Contribution Cycle Type")
                    this.$store.commit('setDialogMessage', "Your njangi meetings, will they hold on daily, weekly or monthly bases, You decide by choosing the options available. <b>After</b> choosing this, the next field you will have to choose the number of days/weeks/months")
                    this.$store.commit('activateDialog', true)
                } else if (this.asset_description_help) {
                    this.asset_description_help = false
                    this.$refs.assets_description.focus()
                    this.$store.commit('setDialogTitle', "Asset Description")
                    this.$store.commit('setDialogMessage', "Please describe your available assets to help us better evaluate your application.")
                    this.$store.commit('activateDialog', true)
                } else if (this.bank_statement_description_help) {
                    this.bank_statement_description_help = false
                    this.$refs.bank_account_description.focus()
                    this.$store.commit('setDialogTitle', "Bank Statement Description")
                    this.$store.commit('setDialogMessage', "Please describe your bank statement to help us better evaluate your application.")
                    this.$store.commit('activateDialog', true)
                }
            },
        },
    }
</script>

<style scoped>
    .caption {
        font-size: 0.75rem !important;
    }

    .body-2 {
        font-size: 0.875rem !important;
    }
</style>